// extracted by mini-css-extract-plugin
export default {"loginDiv":"Login_loginDiv__WKNUx","textDiv":"Login_textDiv__PBXLN","loginForm":"Login_loginForm__85pq4","inputForm":"Login_inputForm__PG+8D","buttonForm":"Login_buttonForm__d5td2"};